export default "__VITE_ASSET__Kkj$g9TU__"